import { twMerge } from "tailwind-merge";
import { ReactNode } from "react";

export const Sidebar = ({ className, children }: { className?: string; children: ReactNode }) => (
  <div className={`${twMerge("hidden min-h-screen bg-[#e9eff7] p-8 lg:block lg:min-w-[380px]", className)}`}>
    {children}
  </div>
);
